import { PickerIconData } from '../types.js'

import { IconPickerIcon } from './IconPickerIcon.js'

type IconPickerCategoryProps = {
  icons: Record<string, PickerIconData[]>
  onIconChange: (icon: PickerIconData) => void
}
export const IconPickerCategory = ({
  icons,
  onIconChange,
}: IconPickerCategoryProps) => {
  return (
    <div className="space-y-3 mb-2">
      {Object.entries(icons).map(([title, icons]) => (
        <div className="grid grid-cols-9 mx-3" key={title}>
          {icons.length > 0 && (
            <>
              <div className="px-2 text-sm col-span-9 mb-1">{title}</div>
              {icons.map(icon => (
                <button
                  key={icon.id}
                  onClick={() => onIconChange(icon)}
                  title={icon.name}
                  type="button"
                  className="flex items-center justify-center w-9 h-9 rounded-full text-content bg-surface hover:bg-surface-hovered transition"
                  tabIndex={-1}
                  // translate3d is added for boosting the scrolling performance
                  style={{ transform: 'translate3d(0, 0, 0)' }}
                >
                  <IconPickerIcon icon={icon} />
                </button>
              ))}
            </>
          )}
        </div>
      ))}
    </div>
  )
}
